export enum FileUploadStatus {
  Uploading = 'uploading',
  Completed = 'completed',
  Faulty = 'faulty',
}
